import jwtDecode from 'jwt-decode';
import { TokenUnpacked } from '../models/token-unpacked';

export default function unpackToken(token: string | null): TokenUnpacked {
  return jwtDecode(token as string);
}
